import { Box, BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ButtonAutoplayBoxStyle = styled(Box)(({ theme }) => ({
  bottom: "7rem",
  cursor:"pointer",
  display:"flex",
  position: "absolute",
  right: "1.5rem",
  zIndex:"5",
  // autoplay si sposta in alto per evitare sovrapposizioni
  [theme.breakpoints.down("sm")]: {
    bottom: "unset",
    top: "2rem"
  }
}));

export const ProgressBoxStyle = styled(Box)<
  BoxProps & { progress:number }
>(({ theme,progress }) => ({
  alignItems: "center",
  backgroundImage:
    `linear-gradient(to right, ${theme.customColors.backgroundPrimaryCta} ${progress}%, `
    + `${theme.customColors.backgroundDisabled} ${progress}%)`,
  borderRadius: "8px",
  cursor:"pointer",
  display: "flex",
  height: "40px",
  overflow: "hidden",
  width:"fit-content"
}));

export const IconBoxStyle = styled(Box)(() => ({
  alignItems:"center",
  display:"flex",
  flexShrink:0,
  height:"16px",
  justifyContent:"center",
  width:"16px"
}));
